import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

const StaticLogo = ({ logo, visible, scene }) => {
  return (
    <CSSTransitionGroup
      transitionName='aw_logo'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={0}
    >
      {visible && <div id={`${scene > 1 ? 'aw_splash__logo-' + scene : 'aw_splash__logo'}`} className={`aw_logo ${scene > 1 ? 'aw_splash__logo-' + scene : 'aw_splash__logo'}`} style={{ backgroundImage: `url(${logo})` }} key='logo' />}
    </CSSTransitionGroup>
  )
}

StaticLogo.propTypes = {
  logo: PropTypes.string,
  visible: PropTypes.bool,
  scene: PropTypes.number
}

export default StaticLogo



// WEBPACK FOOTER //
// ./src/templates/app-website/components/fixed/StaticLogo.js